"use strict";
var anObject = require("../internals/an-object");
var iteratorClose = require("../internals/iterator-close");
module.exports = function(iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator, "throw", error);
  }
};
